
import { mapActions } from 'vuex'
import Heart from '@/assets/icons/fontawesome/light/heart.svg?inline'
import SolidHeart from '@/assets/icons/fontawesome/solid/heart.svg?inline'

export default {
  components: {
    Heart,
    SolidHeart,
  },
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    search: {
      type: Object,
      default: null,
    },
  },
  computed: {
    item() {
      return {
        search: this.search || this.searchQuery,
        property: this.hotel,
      }
    },
  },

  methods: {
    ...mapActions(['addFavorite', 'removeFavorite']),

    ifFavorite(item) {
      for (const index in this.favorites) {
        if (
          this.favorites[index].search.session === item.search.session &&
          this.favorites[index].property.hotel_id === item.property.hotel_id
        ) {
          return true
        }
      }

      return false
    },

    removeFavoriteItem(item) {
      for (const index in this.favorites) {
        if (
          this.favorites[index].search.session === item.search.session &&
          this.favorites[index].property.hotel_id === item.property.hotel_id
        ) {
          this.removeFavorite(index)
        }
      }
    },

    toggle() {
      if (this.ifFavorite(this.item)) {
        this.removeFavoriteItem(this.item)
      } else {
        this.addFavorite(this.item)
      }
    },
  },
}
